import useModal from './modalHook';
import AdminDownloadAllPolicies from '../components/downloadComponents/DownloadAllPolicies';
import ExportPartnerFuelData from '../components/downloadComponents/ExportFuelData';
import { POLICY_REVIEW_STATES } from '../resources/enums';

function useDownload() {
  const { ModalComponent, closeModal, updateModalStates } = useModal();

  const DownloadHookModal = ModalComponent;

  function convertToCSV(data: any) {
    if (!data || data.length === 0) return '';
    
    const headers = Object.keys(data[0]);
    const csvHeaders = headers.join(',');
    
    const csvRows = data.map((row: any) => {
      return headers.map(header => {
        const value = row[header];
        // Handle values that contain commas, quotes, or newlines
        if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      }).join(',');
    });
    
    return [csvHeaders, ...csvRows].join('\n');
  }

  function downloadCSV(data: any) {
    const csvContent = convertToCSV(data);

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'data.csv';
    a.click();
    URL.revokeObjectURL(url);
  }

  function downloadExcel(data: any, fileName = 'policies') {
    const csvContent = convertToCSV(data);

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}.xls`;
    a.click();
    URL.revokeObjectURL(url);
  }

  const fetchFile = (fileUrl: string) => {
    fetch(fileUrl).then((response) => { });
  };

  const showAdminDownloadAllPoliciesModal = (branchStaffs?: any[]) => {
    updateModalStates({
      show: true,
      size: 'md',
      children: (
        <AdminDownloadAllPolicies
          onProceed={() => {
            closeModal();
          }}
          branchStaffs={branchStaffs || []}
          onClose={closeModal}
        />
      ),
      title: 'Export Policies As Excel File',
      classes: '!p-0 r-[5px]'
    });
  };

  const showExportFuelSalesModal = (partnerTeams: any) => {
    updateModalStates({
      show: true,
      size: 'md',
      children: (
        <ExportPartnerFuelData
          onProceed={() => {
            closeModal();
          }}
          onClose={closeModal}
          partnerTeams={partnerTeams}
        />
      ),

      classes: '!p-0 r-[5px]'
    });
  };

  const showExportCustomersWithActivePoliciesModal = () => {
    updateModalStates({
      show: true,
      size: 'md',
      children: (
        <AdminDownloadAllPolicies
          onProceed={() => {
            closeModal();
          }}
          onClose={closeModal}
          reviewStage={POLICY_REVIEW_STATES.APPROVED}
        />
      ),

      classes: '!p-0 r-[5px]'
    });
  };

  return {
    convertToCSV,
    downloadCSV,
    downloadExcel,
    fetchFile,
    showAdminDownloadAllPoliciesModal,
    showExportCustomersWithActivePoliciesModal,
    DownloadHookModal,
    ModalComponent,
    showExportFuelSalesModal
  };
}

export default useDownload;
